import { F, swatchPath, type FieldError, type Frame } from '@glasses/shared'
import { ErrorText } from '../components/ErrorText'

/**
 * One `.frame-card` per catalog frame. Colours are checkboxes, not radios, so the chosen colour
 * can be clicked off (which unticks the frame); the caller keeps it to one colour per frame.
 */
export function FramePicker({
  frames,
  selected,
  errors,
  onToggle,
  onPick,
}: {
  frames: Frame[]
  /** frame id -> chosen colour (null = ticked, no colour yet) */
  selected: Record<string, string | null>
  errors: FieldError[]
  onToggle: (frameId: string, on: boolean) => void
  onPick: (frameId: string, color: string) => void
}) {
  return (
    <div className="frames">
      {frames.map((frame) => {
        const isSelected = frame.id in selected
        const color = selected[frame.id] ?? null
        const title = `${frame.name} #${frame.productNumber}`
        return (
          <div key={frame.id} className={`frame-card ${isSelected ? 'selected' : ''}`} data-frame={frame.id}>
            <label className="frame-pick">
              <input type="checkbox" checked={isSelected} onChange={(e) => onToggle(frame.id, e.target.checked)} />
              {` ${title}`}
            </label>
            <img src={frame.photo} alt={title} />
            <div className="colors" role="group" aria-label={`Color for ${title}`}>
              <span className="colors-label">Color:</span>
              {frame.colors.map((c) => (
                <label key={c} className="chip swatch-chip">
                  <input
                    type="checkbox"
                    value={c}
                    checked={isSelected && color === c}
                    onChange={() => onPick(frame.id, c)}
                  />
                  <img src={swatchPath(frame, c)} alt="" /> {c}
                </label>
              ))}
            </div>
            <ErrorText field={F.frame(frame.id)} errors={errors} />
          </div>
        )
      })}
    </div>
  )
}
